import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;
export const ItemDetailContent_SaltInfoFieldsFragmentDoc = gql`
  fragment ItemDetailContent_SaltInfoFields on OrderEntrySaltInfo {
    name
    description
    long_description
    additional_information {
      name
      value
    }
    image_urls
    packaging {
      name
      value
    }
  }
`;
export const GetOrderEntryItemDetailDocument = gql`
  query GetOrderEntryItemDetail(
    $restaurantId: uuid!
    $supplierId: uuid!
    $variantPackId: uuid!
    $deliveryDate: String!
    $purchaseHistoryLimit: Int
  ) {
    getOrderEntryItemDetail(
      restaurant_id: $restaurantId
      supplier_id: $supplierId
      variant_pack_id: $variantPackId
      delivery_date: $deliveryDate
      purchase_history_limit: $purchaseHistoryLimit
    ) {
      purchase_history {
        base_quantity
        base_unit
        base_unit_price_in_micros
        cost_info {
          details {
            cost_in_micros
            type
          }
        }
        currency_code
        fulfillment_date
        sales_rep_gross_profit_in_percentage
        sales_rep_gross_profit_in_micros
        item_modifiers
        order_date
        order_id
        order_item_id
        price_in_micros
        quantity
        unit
        unit_count
        total_price_in_micros
      }
      related_variant_packs {
        variant_pack_id
        external_item_id
        pack_display_string
        unit_price_in_micros
        currency_code
        availability_status
        salt_info {
          ...ItemDetailContent_SaltInfoFields
        }
      }
      salt_info {
        ...ItemDetailContent_SaltInfoFields
      }
    }
  }
  ${ItemDetailContent_SaltInfoFieldsFragmentDoc}
`;
export function useGetOrderEntryItemDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetOrderEntryItemDetailQuery,
    Types.GetOrderEntryItemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetOrderEntryItemDetailQuery,
    Types.GetOrderEntryItemDetailQueryVariables
  >(GetOrderEntryItemDetailDocument, options);
}
export function useGetOrderEntryItemDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetOrderEntryItemDetailQuery,
    Types.GetOrderEntryItemDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetOrderEntryItemDetailQuery,
    Types.GetOrderEntryItemDetailQueryVariables
  >(GetOrderEntryItemDetailDocument, options);
}
export type GetOrderEntryItemDetailQueryHookResult = ReturnType<
  typeof useGetOrderEntryItemDetailQuery
>;
export type GetOrderEntryItemDetailLazyQueryHookResult = ReturnType<
  typeof useGetOrderEntryItemDetailLazyQuery
>;
export type GetOrderEntryItemDetailQueryResult = Apollo.QueryResult<
  Types.GetOrderEntryItemDetailQuery,
  Types.GetOrderEntryItemDetailQueryVariables
>;

/**
 * Wrapped version of useGeneratedGetOrderEntryItemDetailQuery using Pepper's useWrappedQuery
 */
export function useGeneratedGetOrderEntryItemDetailQuery(
  options?: Apollo.QueryHookOptions<
    Types.GetOrderEntryItemDetailQuery,
    Types.GetOrderEntryItemDetailQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.GetOrderEntryItemDetailQuery,
    Types.GetOrderEntryItemDetailQueryVariables
  >(GetOrderEntryItemDetailDocument, options);
}

/**
 * Wrapped version of useGeneratedGetOrderEntryItemDetailLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedGetOrderEntryItemDetailLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.GetOrderEntryItemDetailQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.GetOrderEntryItemDetailQuery,
    Types.GetOrderEntryItemDetailQueryVariables
  >(GetOrderEntryItemDetailDocument, lazyOptions);
}
